/* eslint-disable no-unused-vars */
import React, { Suspense, useMemo, useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Toaster } from 'react-hot-toast'
import routes from './routes'
import LoadingPage from '@/components/LoadingPage'
import theme from './theme'
import './App.css'
import { AuthProvider } from '@/hooks/AuthContext'
import ZStyleSheet from './helpers/ZStyleSheet'
import { resetDevSession } from '@/helpers/devUtils'
import IdleTimer from '@/components/IdleTimer'

export const DialogStyles = ZStyleSheet.create({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignIitems: 'center'
  }
})

function App() {
  const memoizedTheme = useMemo(() => theme, [])
  const router = createBrowserRouter(routes)

  useEffect(() => {
    // Session-based auth: ensure old localStorage tokens are cleared out
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('refreshToken')

    sessionStorage.setItem('sessionActive', 'true')
  }, [])

  return (
    <AuthProvider>
      <IdleTimer />
      <Suspense fallback={<LoadingPage />}>
        <Toaster />
        <ThemeProvider theme={memoizedTheme}>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <RouterProvider router={router} />
            {(import.meta.env.MODE === 'devlocal' ||
              import.meta.env.MODE === 'devremote' ||
              import.meta.env.DEV) && (
              <button
                onClick={resetDevSession}
                title="Reset Dev Environment"
                style={{
                  position: 'fixed',
                  bottom: '10px',
                  right: '10px',
                  zIndex: 9999,
                  width: '32px',
                  height: '32px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.4)',
                  opacity: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
                onMouseOver={e => {
                  e.currentTarget.style.opacity = 1
                  e.currentTarget.style.width = '120px'
                  e.currentTarget.style.borderRadius = '20px'
                  e.currentTarget.innerText = 'Reset Dev Env'
                  e.currentTarget.style.fontSize = '12px'
                }}
                onMouseOut={e => {
                  e.currentTarget.style.opacity = 0.5
                  e.currentTarget.style.width = '32px'
                  e.currentTarget.style.borderRadius = '50%'
                  e.currentTarget.innerText = '↺'
                  e.currentTarget.style.fontSize = '16px'
                }}
              >
                ↺
              </button>
            )}
          </LocalizationProvider>
        </ThemeProvider>
      </Suspense>
    </AuthProvider>
  )
}

export default App
